import React, { useEffect } from 'react'
import { styled } from '../../../stitches/stitches.config'
import { SliceZone } from '@prismicio/react'
import { vars } from '@seed-design/design-token'
import 'intersection-observer'

import HeaderSlice from '../components/HeaderSection'
import ImageSection from '../components/ImageSection'
import FaqSlice from '../components/FAQSection'
import ButtonSectionSlice from '../components/ButtonSection'
import CardsCarousel from '../components/CardsCarouselSection'
import EmbedSection from '../components/EmbedSection'
import LoggingButtonSection from '../components/LoggingButtonSection'
import ShareButtonSection from '../components/ShareButtonSection'
import FloatingButtonSlice from '../components/FloatingButtonSection'

import type { PrismicDocument } from '@prismicio/types'

const $semantic = vars.$semantic

export function ContentSection({
  document,
}: {
  document?: PrismicDocument<Record<string, any>, string, string>
}) {
  const isFullWidth = document?.tags.includes('full_width')
  if (!document) {
    return null
  }

  return (
    // if document.tag has "full width", full width page.
    <Wrapper fullPage={isFullWidth}>
      {document && (
        <SliceZone
          slices={document.data.body as any[]}
          components={{
            header: HeaderSlice,
            image_section: ImageSection,
            faq_section: FaqSlice,
            buttonsection: ButtonSectionSlice,
            cards_carousel: CardsCarousel,
            embed_content: EmbedSection,
            logging_button: LoggingButtonSection,
            share_button: ShareButtonSection,
            floating_button: FloatingButtonSlice,
          }}
        />
      )}
    </Wrapper>
  )
}

const Wrapper = styled('div', {
  padding: 16,
  backgroundColor: $semantic.color.paperDefault,
  lineHeight: 0,
  variants: {
    fullPage: {
      true: {
        padding: 0,
      },
      false: {},
    },
  },
})
